import LeadSharingForm from 'routes/CommunitySettings/components/LeadSharingForm/LeadSharingForm';

export default LeadSharingForm;
